module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight-16968b124d94ebb8dfa5962250eac2b0.png";